import styled from 'styled-components';

import colors from 'theme/colors';
import { FunctionComponent } from 'react';
import Layout, { LayoutProps } from 'antd/lib/layout';
import Breadcrumb from 'antd/lib/breadcrumb';

const { Content, Header } = Layout;

interface KennelLayoutProps extends LayoutProps {
  padding?: string;
}

export const LayoutStyled: FunctionComponent<KennelLayoutProps> = styled(Layout)`
  background: ${colors.background};
  padding: ${(props: KennelLayoutProps) => props.padding ?? 0};
`;

export const SectionStyled = styled.section`
  margin: 1rem 0;
  padding: 1.5rem;
  background: white;
  min-height: 256px;
`;

export const NavigationUserName = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  max-width: 10rem;

  div:first-of-type {
    border-radius: 50%;
    border: none;
    background-color: rgba(24, 144, 255, 0.25);
    width: 2rem;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 0.5rem;
  }

  div:last-of-type {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100px;
  }
`;

export const BreadcrumbStyled = styled(Breadcrumb)`
  margin-bottom: 1rem;
  margin-top: -1rem;
`;

export const ContentStyled = styled(Content)`
  padding: 2rem;
`;

export const HeaderStyled = styled(Header)`
  display: flex;
  flex-direction: row;
  align-items: center;
  background: white;
  box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.15);
  justify-content: space-between;
  padding-right: 1.2rem;
  padding-left: 1.2rem;
`;

export const TitleStyled = styled.div`
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 1.313rem;

  .title-dash {
    font-weight: normal;
    color: rgba(0, 0, 0, 0.35);
    border-right: 2px solid rgba(0, 0, 0, 0.35);
    height: 1.375rem;
    margin-right: 0.625rem;
    margin-top: -0.313rem;
  }

  span:nth-child(2) {
    margin-top: -0.375rem;
    padding-right: 0.8rem;
  }
`;

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
`;
